import { render } from "./RevisarEntradaPage.vue?vue&type=template&id=6ddadd9f&scoped=true"
import script from "./RevisarEntradaPage.vue?vue&type=script&lang=js"
export * from "./RevisarEntradaPage.vue?vue&type=script&lang=js"

import "./RevisarEntradaPage.vue?vue&type=style&index=0&id=6ddadd9f&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddadd9f"]])

export default __exports__